/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeExtendedConfigurationTask
 */
export interface ChangeExtendedConfigurationTask {
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    componentName?: string;
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    componentInstance?: string;
    /**
     *
     * @type {number}
     * @memberof ChangeExtendedConfigurationTask
     */
    connectorId?: number;
    /**
     *
     * @type {number}
     * @memberof ChangeExtendedConfigurationTask
     */
    physicalPlugId?: number;
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    variableName?: string;
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    variableInstance?: string;
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    attribute?: string;
    /**
     *
     * @type {string}
     * @memberof ChangeExtendedConfigurationTask
     */
    value?: string;
}

/**
 * Check if a given object implements the ChangeExtendedConfigurationTask interface.
 */
export function instanceOfChangeExtendedConfigurationTask(
    value: object,
): value is ChangeExtendedConfigurationTask {
    return true;
}

export function ChangeExtendedConfigurationTaskFromJSON(
    json: any,
): ChangeExtendedConfigurationTask {
    return ChangeExtendedConfigurationTaskFromJSONTyped(json, false);
}

export function ChangeExtendedConfigurationTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChangeExtendedConfigurationTask {
    if (json == null) {
        return json;
    }
    return {
        componentName:
            json["componentName"] == null ? undefined : json["componentName"],
        componentInstance:
            json["componentInstance"] == null
                ? undefined
                : json["componentInstance"],
        connectorId:
            json["connectorId"] == null ? undefined : json["connectorId"],
        physicalPlugId:
            json["physicalPlugId"] == null ? undefined : json["physicalPlugId"],
        variableName:
            json["variableName"] == null ? undefined : json["variableName"],
        variableInstance:
            json["variableInstance"] == null
                ? undefined
                : json["variableInstance"],
        attribute: json["attribute"] == null ? undefined : json["attribute"],
        value: json["value"] == null ? undefined : json["value"],
    };
}

export function ChangeExtendedConfigurationTaskToJSON(
    value?: ChangeExtendedConfigurationTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        componentName: value["componentName"],
        componentInstance: value["componentInstance"],
        connectorId: value["connectorId"],
        physicalPlugId: value["physicalPlugId"],
        variableName: value["variableName"],
        variableInstance: value["variableInstance"],
        attribute: value["attribute"],
        value: value["value"],
    };
}
